import { clearPspReturnPending, readPspReturnPending } from '@/shared/lib/pspReturn'

export type PaymentCheckoutOutcome = 'success' | 'cancel'

export function readCheckoutOutcome(search: Record<string, unknown>): PaymentCheckoutOutcome | null {
  const checkout = search.checkout
  if (checkout === 'success' || checkout === 'cancel') {
    return checkout
  }
  return null
}

export function hasPaymentReturnSignal(search: Record<string, unknown>): boolean {
  if (readCheckoutOutcome(search) !== null) {
    return true
  }
  if (typeof search.checkout_session_id === 'string' && search.checkout_session_id !== '') {
    return true
  }
  if (typeof search.session_id === 'string' && search.session_id !== '') {
    return true
  }
  return readPspReturnPending() !== null
}

/** Strip PSP query params after handling (keep path). */
export function cleanPaymentReturnSearch(search: Record<string, unknown>): Record<string, unknown> {
  const next = { ...search }
  delete next.checkout
  delete next.checkout_session_id
  delete next.session_id
  return next
}

export function consumePspReturnPending(): void {
  clearPspReturnPending()
}

export function readWindowSearchRecord(): Record<string, unknown> {
  if (typeof window === 'undefined') {
    return {}
  }

  const record: Record<string, unknown> = {}
  for (const [key, value] of new URLSearchParams(window.location.search)) {
    record[key] = value
  }

  return record
}

export function readWindowPathname(): string {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.pathname
}
